/**
 * Main JavaScript File
 */

// Template Parts
import { header } from './template-parts/header/header'

// ACF Blocks
import { initTestimonialsSlider } from './template-parts/blocks/testimonials-slider'
import { initLogosSlider } from './template-parts/blocks/logos-slider'

import { videoBlock, videoOrganizations } from './template-parts/blocks/video'
import { counterNumbers } from './template-parts/blocks/counter-numbers'
import { initTeamBlock } from './template-parts/blocks/team-block'
import { mapBlock } from './template-parts/blocks/map-block'
import { skipBlock } from './template-parts/blocks/skip-block'
import { WL_Order } from './template-parts/blocks/wl-order'

// Components
import { appearence } from './components/animations/appearence'
import { scrollToAnchor } from './components/animations/scroll-to-anchor'


import { blogLoadMore } from './utils/loadmore'
import { orphansKiller } from './utils/orphans'

// Utils
import 'bootstrap/js/src/collapse'

// Components
appearence()
scrollToAnchor()

// Template Parts
header()

// ACF Blocks
initTestimonialsSlider()
initLogosSlider()
videoBlock()
videoOrganizations()
counterNumbers()
initTeamBlock()
mapBlock()
skipBlock()
WL_Order()

// Utils
blogLoadMore();
//orphansKiller();
// videoSize()
